import { useState } from "react";
import { AttributeFieldProps } from "./RenderAttributeInput";
import GetAttributeDefinition, { AttributeTargetType, GetComponentOrStyleValueFromDefinition } from "../Data/WBData";
import { attributeTypes } from "vagaro-website-rendering/src/components/Definitions/AttributeTypes";
import SelectField from "./SelectField";
import MeasurementField from "./MeasurementField";
import ColorInputField from "./ColorInputField";
import { UpdateStyleFunction } from "../Stylebuilder";


export default function BorderField({label,definition,layoutObject,updateFunc,screenSize,saveFunc,siteData}:AttributeFieldProps){


    const borderStyleDef = definition;
    const borderWidthDef = GetAttributeDefinition(attributeTypes.borderWidth);
    const borderColorDef = GetAttributeDefinition(attributeTypes.borderColor);

    const updateSelect : UpdateStyleFunction = (  
      attribute: string,
      value: string,
      targetType: AttributeTargetType)=>{
        
        updateFunc(attribute,value,targetType);
        setBorderStyle(value);
      
    }

  const [borderStyle, setBorderStyle] = useState(GetComponentOrStyleValueFromDefinition(borderStyleDef, layoutObject, screenSize));
    

    return (
      <div className="wb-input-group no-border" style={{padding:"0px"}}>
       
            
        <SelectField label={label} definition={borderStyleDef} layoutObject={layoutObject} updateFunc={updateSelect} saveFunc = {saveFunc} screenSize={screenSize} siteData={siteData}/>
     
          {borderStyle!="none" &&borderStyle!="" &&
          <>
          <MeasurementField label={"Border Width"} definition={borderWidthDef} layoutObject={layoutObject} updateFunc={updateFunc} screenSize={screenSize} saveFunc={saveFunc} siteData={siteData} isFourWay={true} />
          <ColorInputField label={"Border Color"} definition={borderColorDef} layoutObject={layoutObject} updateFunc={updateFunc} screenSize={screenSize} saveFunc={saveFunc} siteData={siteData} />
          </>
        }
      
      
        
     
      </div>
    );

}